import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { localApi, credentials } from "utils/imgApi";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Selects from "react-select";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import CustomInput from "components/CustomInput/CustomInput.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import { AiOutlineFolderView } from "react-icons/ai";
import SweetAlert from "react-bootstrap-sweetalert";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import styleSweet from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import styDrop from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import axios from "axios";
import ImageKit from "imagekit-javascript";

const useStyles = makeStyles(styles);
const useStyl = makeStyles(styDrop);
const useStyleSweet = makeStyles(styleSweet);

const INITIAL_TOUCHED = {
  image: false,
  simpleSelect: false,
  simpleSelect1: false,
  description: false,
  metal: false,
  making: false,
  readyGram: false,
  metalGram: false,
  endDate: false,
  hashtags: false,
};

function formatDateDDMMYYYY(date) {
  if (!date) return "Not selected";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}

function getLocalDateInputValue(date) {
  if (!date) return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

function createLocalDate(dateString) {
  if (!dateString) return null;

  const [year, month, day] = dateString.split("-").map(Number);

  const date = new Date(year, month - 1, day);
  date.setHours(0, 0, 0, 0);

  return date;
}

function formatEndDateForJson(date) {
  if (!date) return null;

  const localDate = new Date(date);
  localDate.setHours(0, 0, 0, 0);

  return localDate.toISOString();
}

export default function UpdatePosts() {
  const [itemPosts, setItemPosts] = React.useState([]);
  const [items, setItems] = useState([]);
  const [items1, setItems1] = useState([]);

  const [simpleSelectProd, setSimpleSelectProd] = React.useState("");
  const [simpleSelectProdErr, setSimpleSelectProdErr] = React.useState("");
  const [postsObj, setPostsObj] = React.useState("");

  // Dropdown IDs
  const [simpleSelect, setSimpleSelect] = useState("");
  const [simpleSelect1, setSimpleSelect1] = useState("");

  // Dropdown display values sent in payload
  const [category, setCategory] = useState("");
  const [sizeMM, setSizeMM] = useState("");

  const [readyGram, setReadyGram] = useState("0.0075");
  const [metalGram, setMetalGram] = useState("0.0100");
  const [description, setDescription] = useState("");
  const [metal, setMetal] = useState("");
  const [making, setMaking] = useState("");
  const [offer, setOffer] = useState("");
  const [hashtags, setHashtags] = useState("");

  const [imageFile, setImageFile] = useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  const [existingImageUrl, setExistingImageUrl] = useState("");

  const [startDate] = useState(() => {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    return date;
  });

  const [endDate, setEndDate] = useState(null);

  const [alertType, setAlertType] = useState("");
  const [alertMsg, setAlertMsg] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const [touched, setTouched] = useState(INITIAL_TOUCHED);

  const classes = useStyles();
  const classe = useStyl();
  const classSweet = useStyleSweet();
  const fileInputRef = useRef(null);

  const maxEnd = new Date(startDate);
  maxEnd.setMonth(maxEnd.getMonth() + 3);
  maxEnd.setHours(0, 0, 0, 0);

  const userObj = (() => {
    try {
      const sessionData = sessionStorage.getItem("sessionData");
      return sessionData ? JSON.parse(sessionData) : null;
    } catch (error) {
      console.error("Error parsing session data:", error);
      return null;
    }
  })();

  async function getUsers() {
    const api = localApi + `/posts/list/byAdminId/${userObj && userObj.id}`;

    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });

    const getResult = await result.json();
    setItemPosts(getResult && getResult);
  }

  useEffect(() => {
    getUsers();
  }, []);

  /*
   * Select an existing post and load all post details.
   */
  const handleSimpleProd = async (selectedOption) => {
    setSimpleSelectProd(selectedOption || "");
    setSimpleSelectProdErr("");

    if (!selectedOption?.value) {
      setPostsObj("");
      setSimpleSelect("");
      setSimpleSelect1("");
      setCategory("");
      setSizeMM("");
      setDescription("");
      setMetal("");
      setMaking("");
      setReadyGram("0.0075");
      setMetalGram("0.0100");
      setEndDate(null);
      setHashtags("");
      setItems1([]);
      setImageFile(null);
      setExistingImageUrl("");
      setImagePreviewUrl(null);

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      return;
    }

    const postId = String(selectedOption.value).split(" - ")[0].trim();

    const selectedPost = itemPosts.find(
      (post) => String(post.id) === String(postId),
    );

    // console.log(selectedPost);

    if (!selectedPost) {
      console.error("Selected post was not found:", postId);

      setPostsObj("");
      setSimpleSelect("");
      setSimpleSelect1("");
      setCategory("");
      setSizeMM("");
      setItems1([]);
      setImageFile(null);
      setExistingImageUrl("");
      setImagePreviewUrl(null);
      setSimpleSelectProdErr("Selected post was not found.");

      return;
    }

    setPostsObj(selectedPost);

    const categoryId = selectedPost.categoryId ?? "";
    const sizeId = selectedPost.sizemmId ?? "";

    setSimpleSelect(categoryId ? String(categoryId) : "");
    setSimpleSelect1(sizeId ? String(sizeId) : "");

    setCategory(selectedPost.category ?? "");
    setSizeMM(selectedPost.sizemm ?? "");

    setDescription(selectedPost.description ?? "");

    setMetal(
      selectedPost.metal !== null && selectedPost.metal !== undefined
        ? String(selectedPost.metal)
        : "",
    );

    setMaking(
      selectedPost.making !== null && selectedPost.making !== undefined
        ? String(selectedPost.making)
        : "",
    );

    setReadyGram(
      selectedPost.readyGram !== null && selectedPost.readyGram !== undefined
        ? String(selectedPost.readyGram)
        : "0.0075",
    );

    setMetalGram(
      selectedPost.metalGram !== null && selectedPost.metalGram !== undefined
        ? String(selectedPost.metalGram)
        : "0.0100",
    );

    setOffer(selectedPost.offer ?? "");
    setHashtags(selectedPost.hashtag ?? "");

    /*
     * Load existing image from API.
     *
     * Example:
     * selectedPost.image =
     * "https://picsum.photos/600/750?random=2"
     */
    const apiImageUrl =
      typeof selectedPost.image === "string" ? selectedPost.image.trim() : "";

    setExistingImageUrl(apiImageUrl);
    setImagePreviewUrl(apiImageUrl || null);

    // A new file is not selected yet.
    setImageFile(null);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    /*
     * Convert API endDate to a local Date object.
     */
    let parsedEndDate = null;

    if (selectedPost.endDate) {
      const endDateValue = String(selectedPost.endDate);

      if (/^\d{4}-\d{2}-\d{2}$/.test(endDateValue)) {
        parsedEndDate = createLocalDate(endDateValue);
      } else {
        const parsedDate = new Date(endDateValue);

        if (!Number.isNaN(parsedDate.getTime())) {
          parsedEndDate = new Date(
            parsedDate.getFullYear(),
            parsedDate.getMonth(),
            parsedDate.getDate(),
          );

          parsedEndDate.setHours(0, 0, 0, 0);
        }
      }
    }

    setEndDate(parsedEndDate);

    setTouched((previous) => ({
      ...previous,
      image: false,
      simpleSelect: false,
      simpleSelect1: false,
      endDate: false,
    }));

    setItems1([]);

    if (!categoryId) {
      return;
    }

    try {
      const response = await axios.get(
        `${localApi}/parent/list/byCategoryId/${categoryId}`,
        {
          headers: {
            Authorization: `Basic ${credentials}`,
          },
        },
      );

      setItems1(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Error fetching bangle sizes:", error);
      setItems1([]);
    }
  };

  /*
   * Validation errors.
   */
  const categoryError = touched.simpleSelect && !String(simpleSelect).trim();

  const sizeError = touched.simpleSelect1 && !String(simpleSelect1).trim();

  const readyGramError =
    touched.readyGram && (!String(readyGram).trim() || Number(readyGram) <= 0);

  const metalGramError =
    touched.metalGram && (!String(metalGram).trim() || Number(metalGram) <= 0);

  const fetchCat = async () => {
    if (!userObj?.id) {
      console.error("User ID is not available in session storage.");
      return;
    }

    try {
      const response = await fetch(
        `${localApi}/category/list/byAdminId/${userObj.id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Basic ${credentials}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error(`Failed to load categories: ${response.status}`);
      }

      const data = await response.json();
      setItems(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Category fetch error:", error);
      setItems([]);
    }
  };

  useEffect(() => {
    fetchCat();
  }, []);

  useEffect(() => {
    return () => {
      if (imagePreviewUrl && imagePreviewUrl.startsWith("blob:")) {
        URL.revokeObjectURL(imagePreviewUrl);
      }
    };
  }, [imagePreviewUrl]);

  const handleSimple = async (event) => {
    const value = String(event.target.value);

    const selectedCategory = items.find((item) => String(item.id) === value);

    setSimpleSelect(value);
    setCategory(selectedCategory?.title || "");

    // A new category must clear old selected size.
    setSimpleSelect1("");
    setSizeMM("");
    setItems1([]);

    setTouched((previous) => ({
      ...previous,
      simpleSelect: true,
      simpleSelect1: false,
    }));

    if (!selectedCategory) {
      return;
    }

    try {
      const response = await axios.get(
        `${localApi}/parent/list/byCategoryId/${selectedCategory.id}`,
        {
          headers: {
            Authorization: `Basic ${credentials}`,
          },
        },
      );

      setItems1(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Error fetching bangle sizes:", error);
      setItems1([]);
    }
  };

  const handleSimple1 = (event) => {
    const value = String(event.target.value);

    const selectedSize = items1.find((item) => String(item.id) === value);

    setSimpleSelect1(value);
    setSizeMM(selectedSize?.title || "");

    setTouched((previous) => ({
      ...previous,
      simpleSelect1: true,
    }));
  };

  const onPickImage = (event) => {
    const file = event.target.files?.[0];

    setTouched((previous) => ({
      ...previous,
      image: true,
    }));

    if (!file) {
      return;
    }

    if (!file.type.startsWith("image/")) {
      event.target.value = "";
      setImageFile(null);

      if (existingImageUrl) {
        setImagePreviewUrl(existingImageUrl);
      } else {
        setImagePreviewUrl(null);
      }

      return;
    }

    if (imagePreviewUrl && imagePreviewUrl.startsWith("blob:")) {
      URL.revokeObjectURL(imagePreviewUrl);
    }

    const previewUrl = URL.createObjectURL(file);

    setImageFile(file);
    setImagePreviewUrl(previewUrl);
  };

  const onEndDateChange = (event) => {
    const selectedValue = event.target.value;

    setTouched((previous) => ({
      ...previous,
      endDate: true,
    }));

    if (!selectedValue) {
      setEndDate(null);
      return;
    }

    const selectedDate = createLocalDate(selectedValue);
    const minimumDate = createLocalDate(getLocalDateInputValue(startDate));
    const maximumDate = createLocalDate(getLocalDateInputValue(maxEnd));

    if (
      !selectedDate ||
      selectedDate < minimumDate ||
      selectedDate > maximumDate
    ) {
      setEndDate(null);
      event.target.value = "";
      return;
    }

    setEndDate(selectedDate);
  };

  const isPositiveNumber = (value) => {
    const parsedValue = Number(String(value).trim());

    return Number.isFinite(parsedValue) && parsedValue > 0;
  };

  const validateForm = () => {
    const errors = {
      // Existing API image or newly selected file is valid.
      image: !imageFile && !imagePreviewUrl,
      simpleSelect: !String(simpleSelect).trim(),
      simpleSelect1: !String(simpleSelect1).trim(),
      description: !description.trim(),
      metal: !metal.trim(),
      making: !making.trim(),
      readyGram: !isPositiveNumber(readyGram),
      metalGram: !isPositiveNumber(metalGram),
      endDate: !endDate,
      hashtags: !hashtags.trim(),
    };

    const isValid = !Object.values(errors).some(Boolean);

    // This makes every invalid field show its error after Save button click.
    setTouched({
      image: true,
      simpleSelect: true,
      simpleSelect1: true,
      description: true,
      metal: true,
      making: true,
      readyGram: true,
      metalGram: true,
      endDate: true,
      hashtags: true,
    });

    return isValid;
  };

  const resetForm = () => {
    setDescription("");
    setMetal("");
    setMaking("");
    setHashtags("");

    setSimpleSelect("");
    setSimpleSelect1("");
    setCategory("");
    setSizeMM("");
    setItems1([]);

    setReadyGram("0.0075");
    setMetalGram("0.0100");

    setEndDate(null);
    setImageFile(null);
    setExistingImageUrl("");
    setPostsObj("");
    setSimpleSelectProd("");

    if (imagePreviewUrl && imagePreviewUrl.startsWith("blob:")) {
      URL.revokeObjectURL(imagePreviewUrl);
    }

    setImagePreviewUrl(null);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    setTouched(INITIAL_TOUCHED);
  };

  const handleUpdate = async () => {
    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      let imageUrl = postsObj?.image || "";

      if (imageFile) {
        const authResponse = await fetch(
          `${localApi}/imageskitauth/auth/${userObj.id}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: `Basic ${credentials}`,
            },
          },
        );

        const authText = await authResponse.text();

        let authData;

        try {
          authData = authText ? JSON.parse(authText) : {};
        } catch {
          throw new Error(
            "Invalid response received from ImageKit authentication API.",
          );
        }

        if (!authResponse.ok) {
          throw new Error(
            authData?.message ||
              authData?.error ||
              "Failed to get ImageKit authentication.",
          );
        }

        const { token, expire, signature, publicKey, urlEndpoint } = authData;

        if (!token || !expire || !signature || !publicKey || !urlEndpoint) {
          throw new Error("ImageKit authentication response is incomplete.");
        }

        const imagekit = new ImageKit({
          publicKey,
          urlEndpoint,
        });

        const fileExtension = imageFile.name.includes(".")
          ? imageFile.name.substring(imageFile.name.lastIndexOf("."))
          : "";

        const uniqueFileName = `product_${
          userObj.id
        }_${Date.now()}${fileExtension}`;

        const imageKitResponse = await imagekit.upload({
          file: imageFile,
          fileName: uniqueFileName,
          token,
          expire,
          signature,
          folder: "/products",
          useUniqueFileName: true,
        });

        imageUrl = imageKitResponse?.url;

        if (!imageUrl) {
          throw new Error("ImageKit did not return an image URL.");
        }
      }

      const payload = {
        image: imageUrl,
        description: description.trim(),
        metal: metal.trim(),
        making: making.trim(),
        offer: offer?.trim(),
        hashtag: hashtags.trim(),
        readyGram: readyGram.trim(),
        metalGram: metalGram.trim(),
        categoryId: category.id || simpleSelect,
        category: category.title || category,
        sizemmId: sizeMM.id || simpleSelect1,
        sizemm: sizeMM.title || sizeMM,
        endDate: formatEndDateForJson(endDate),
      };

      const response = await fetch(
        `${localApi}/posts/update/postsById/${postsObj.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${credentials}`,
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      if (data?.message === "Data Updated Successfully !!!") {
        setAlertType("success");
        setAlertMsg("Posts Saved Successfully.");
        setSubmitted(true);
      }
    } catch (error) {
      console.error("Save error:", error);

      setAlertType("error");
      setAlertMsg(error.message || "Failed to save Posts. Please try again.");
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  const hideAlert = () => {
    setSubmitted(false);
    window.location.reload(false);
  };

  const getLabelColor = (field, value) => {
    const isEmpty = !value || (typeof value === "string" && !value.trim());

    return touched[field] && isEmpty ? "#f44336" : "#777";
  };

  const imageLabelColor =
    touched.image && !imageFile && !imagePreviewUrl ? "#f44336" : "#777";

  const select = {
    width: "100%",
    maxWidth: 600,
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      padding: 10,
    }),

    menu: (state) => ({
      color: "#d81b60",
    }),

    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";

      return {
        ...provided,
        opacity,
        transition,
      };
    },
  };

  return (
    <div>
      <GridContainer
        justify="center"
        alignItems="center"
        style={{ marginBottom: "5%" }}
      >
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <AiOutlineFolderView />
              </CardIcon>

              <h3 className={classes.cardIconTitle}>
                <small>Update Posts</small>
              </h3>
            </CardHeader>

            <CardBody>
              <GridContainer>
                {submitted && (
                  <SweetAlert
                    type={alertType}
                    style={{
                      display: "block",
                      marginTop: "-100px",
                    }}
                    title={alertMsg}
                    onConfirm={hideAlert}
                    confirmBtnCssClass={
                      classSweet.button + " " + classSweet.success
                    }
                  />
                )}

                <GridItem xs={12} sm={12} md={12}>
                  <label className={classe.selectLabel}>Select Posts Id</label>

                  <Selects
                    styles={customStyles}
                    style={select}
                    required={true}
                    placeholder="Select Posts Id..."
                    value={simpleSelectProd}
                    name="simpleSelectProd"
                    onChange={handleSimpleProd}
                    options={
                      itemPosts &&
                      itemPosts.map((c) => ({
                        label: `${c.id} - ${c.category} - ${c.sizemm}`,
                        value: `${c.id} - ${c.category} - ${c.sizemm}`,
                      }))
                    }
                  />

                  {simpleSelectProdErr && (
                    <div
                      style={{
                        color: "#f44336",
                        fontSize: 12,
                        marginTop: 4,
                      }}
                    >
                      {simpleSelectProdErr}
                    </div>
                  )}
                </GridItem>

                {simpleSelectProd ? (
                  <>
                    {/* Product Image */}
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        id="product-image-input"
                        label="Product Image"
                        type="file"
                        onChange={onPickImage}
                        disabled={loading}
                        inputProps={{
                          ref: fileInputRef,
                          accept: "image/*",
                        }}
                      />

                      <label
                        htmlFor="product-image-input"
                        style={{
                          border: `1px solid ${imageLabelColor}`,
                          borderRadius: 6,
                          padding: 8,
                          cursor: loading ? "not-allowed" : "pointer",
                          display: "block",
                          backgroundColor: loading ? "#f9f9f9" : "#fff",
                          opacity: loading ? 0.7 : 1,
                          marginTop: 6,
                        }}
                      >
                        {imagePreviewUrl ? (
                          <div
                            style={{
                              position: "relative",
                              display: "flex",
                              justifyContent: "center",
                              width: "100%",
                            }}
                          >
                            <img
                              src={imagePreviewUrl}
                              alt="Product preview"
                              style={{
                                width: "100%",
                                maxHeight: 240,
                                borderRadius: 6,
                                objectFit: "cover",
                                display: "block",
                              }}
                            />

                            <div
                              style={{
                                position: "absolute",
                                bottom: 8,
                                left: 8,
                                backgroundColor: "rgba(0,0,0,0.7)",
                                color: "#fff",
                                padding: "4px 10px",
                                borderRadius: 4,
                                fontSize: 12,
                                fontWeight: 600,
                              }}
                            >
                              Change Photo
                            </div>
                          </div>
                        ) : (
                          <div
                            style={{
                              width: "100%",
                              height: 160,
                              backgroundColor: "#f5f5f5",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "#888",
                              borderRadius: 6,
                              border: "1px dashed #ccc",
                            }}
                          >
                            📷 Tap to add photo
                          </div>
                        )}
                      </label>

                      {touched.image && !imageFile && !imagePreviewUrl && (
                        <div
                          style={{
                            color: "#f44336",
                            fontSize: 12,
                            marginTop: 4,
                          }}
                        >
                          Product image is required.
                        </div>
                      )}
                    </GridItem>

                    {/* Category Dropdown */}
                    <GridItem xs={12} sm={6} md={6}>
                      <FormControl
                        fullWidth
                        error={categoryError}
                        className={classe.selectFormControl}
                      >
                        <InputLabel
                          htmlFor="simple-select"
                          className={classe.selectLabel}
                          style={{
                            color: categoryError
                              ? "#f44336 !important"
                              : "#777 !important",
                          }}
                        >
                          Select Category Name...
                        </InputLabel>

                        <Select
                          id="simple-select"
                          name="simpleSelect"
                          value={simpleSelect}
                          onChange={handleSimple}
                          onBlur={() => {
                            setTouched((previous) => ({
                              ...previous,
                              simpleSelect: true,
                            }));
                          }}
                          disabled={loading}
                          error={categoryError}
                          classes={{
                            select: classe.select,
                          }}
                          MenuProps={{
                            className: classe.selectMenu,
                          }}
                          style={{
                            borderBottom: `1px solid ${
                              categoryError ? "#f44336" : "#ccc"
                            }`,
                          }}
                        >
                          <MenuItem
                            disabled
                            value=""
                            classes={{
                              root: classe.selectMenuItem,
                            }}
                          >
                            Select Category Name...
                          </MenuItem>

                          {items.map((item) => (
                            <MenuItem
                              key={item.id}
                              value={String(item.id)}
                              classes={{
                                root: classe.selectMenuItem,
                                selected: classe.selectMenuItemSelected,
                              }}
                            >
                              {item.title}
                            </MenuItem>
                          ))}
                        </Select>

                        {categoryError && (
                          <div
                            style={{
                              color: "#f44336",
                              fontSize: 12,
                              marginTop: 4,
                            }}
                          >
                            Category is required.
                          </div>
                        )}
                      </FormControl>
                    </GridItem>

                    {/* Bangle Size Dropdown */}
                    <GridItem xs={12} sm={6} md={6}>
                      <FormControl
                        fullWidth
                        error={sizeError}
                        className={classe.selectFormControl}
                      >
                        <InputLabel
                          htmlFor="simple-select1"
                          className={classe.selectLabel}
                          style={{
                            color: sizeError
                              ? "#f44336 !important"
                              : "#777 !important",
                          }}
                        >
                          Select Bangles Size-MM...
                        </InputLabel>

                        <Select
                          id="simple-select1"
                          name="simpleSelect1"
                          value={simpleSelect1}
                          onChange={handleSimple1}
                          onBlur={() => {
                            setTouched((previous) => ({
                              ...previous,
                              simpleSelect1: true,
                            }));
                          }}
                          disabled={loading || !simpleSelect}
                          error={sizeError}
                          classes={{
                            select: classe.select,
                          }}
                          MenuProps={{
                            className: classe.selectMenu,
                          }}
                          style={{
                            borderBottom: `1px solid ${
                              sizeError ? "#f44336" : "#ccc"
                            }`,
                          }}
                        >
                          <MenuItem
                            disabled
                            value=""
                            classes={{
                              root: classe.selectMenuItem,
                            }}
                          >
                            Select Bangles Size-MM...
                          </MenuItem>

                          {items1.map((item) => (
                            <MenuItem
                              key={item.id}
                              value={String(item.id)}
                              classes={{
                                root: classe.selectMenuItem,
                                selected: classe.selectMenuItemSelected,
                              }}
                            >
                              {item.title}
                            </MenuItem>
                          ))}
                        </Select>

                        {sizeError && (
                          <div
                            style={{
                              color: "#f44336",
                              fontSize: 12,
                              marginTop: 4,
                            }}
                          >
                            Bangle size is required.
                          </div>
                        )}
                      </FormControl>
                    </GridItem>

                    {/* Description */}
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText={
                          <span
                            style={{
                              color: getLabelColor("description", description),
                            }}
                          >
                            Description...
                          </span>
                        }
                        id="description"
                        inputProps={{
                          placeholder: "e.g. Handmade Brass Bangles",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="description"
                        value={description}
                        onChange={(event) => {
                          setDescription(event.target.value);
                          setTouched((previous) => ({
                            ...previous,
                            description: true,
                          }));
                        }}
                        disabled={loading}
                      />
                    </GridItem>

                    {/* Metal */}
                    <GridItem xs={6} sm={6} md={6}>
                      <CustomInput
                        labelText={
                          <span
                            style={{
                              color: getLabelColor("metal", metal),
                            }}
                          >
                            Metal Rate +...
                          </span>
                        }
                        id="metal"
                        inputProps={{
                          placeholder: "e.g. 975",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="metal"
                        value={metal}
                        onChange={(event) => {
                          setMetal(event.target.value);
                          setTouched((previous) => ({
                            ...previous,
                            metal: true,
                          }));
                        }}
                        disabled={loading}
                      />
                    </GridItem>

                    {/* Making */}
                    <GridItem xs={6} sm={6} md={6}>
                      <CustomInput
                        labelText={
                          <span
                            style={{
                              color: getLabelColor("making", making),
                            }}
                          >
                            + Making Cost/Set...
                          </span>
                        }
                        id="making"
                        inputProps={{
                          placeholder: "e.g. 42.00",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="making"
                        value={making}
                        onChange={(event) => {
                          setMaking(event.target.value);
                          setTouched((previous) => ({
                            ...previous,
                            making: true,
                          }));
                        }}
                        disabled={loading}
                      />
                    </GridItem>

                    {/* Metal Gram */}
                    <GridItem xs={6} sm={6} md={6}>
                      <CustomInput
                        labelText={
                          <span
                            style={{
                              color: metalGramError ? "#f44336" : "#777",
                            }}
                          >
                            Metal Gram/Set
                          </span>
                        }
                        id="metalGram"
                        inputProps={{
                          type: "number",
                          inputProps: {
                            min: "0.0001",
                            step: "0.0001",
                          },
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="metalGram"
                        value={metalGram}
                        onChange={(event) => {
                          setMetalGram(event.target.value);
                          setTouched((previous) => ({
                            ...previous,
                            metalGram: true,
                          }));
                        }}
                        disabled={loading}
                      />

                      {metalGramError && (
                        <div
                          style={{
                            color: "#f44336",
                            fontSize: 12,
                            marginTop: -10,
                          }}
                        >
                          Enter a valid Metal Gram value.
                        </div>
                      )}
                    </GridItem>

                    {/* Ready Gram */}
                    <GridItem xs={6} sm={6} md={6}>
                      <CustomInput
                        labelText={
                          <span
                            style={{
                              color: readyGramError ? "#f44336" : "#777",
                            }}
                          >
                            Ready Gram/Set
                          </span>
                        }
                        id="readyGram"
                        inputProps={{
                          type: "number",
                          inputProps: {
                            min: "0.0001",
                            step: "0.0001",
                          },
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="readyGram"
                        value={readyGram}
                        onChange={(event) => {
                          setReadyGram(event.target.value);
                          setTouched((previous) => ({
                            ...previous,
                            readyGram: true,
                          }));
                        }}
                        disabled={loading}
                      />

                      {readyGramError && (
                        <div
                          style={{
                            color: "#f44336",
                            fontSize: 12,
                            marginTop: -10,
                          }}
                        >
                          Enter a valid Ready Gram value.
                        </div>
                      )}
                    </GridItem>

                    {/* Date Range */}
                    <GridItem xs={12} sm={6} md={6}>
                      <div
                        style={{
                          fontSize: 14,
                          color: "#050505",
                          marginTop: 8,
                          marginBottom: 4,
                          fontWeight: 600,
                        }}
                      >
                        Post Visibility (Date Range)
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          border: "1px solid #DDDFE2",
                          borderRadius: 6,
                          backgroundColor: "#fff",
                          padding: "8px 10px",
                          marginTop: 4,
                          minHeight: 40,
                          boxSizing: "border-box",
                        }}
                      >
                        <div
                          style={{
                            fontSize: 14,
                            color: "#050505",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {formatDateDDMMYYYY(startDate)} to{" "}
                          <span
                            style={{
                              fontWeight: 700,
                              color:
                                touched.endDate && !endDate
                                  ? "#f44336"
                                  : "#956d11",
                            }}
                          >
                            {formatDateDDMMYYYY(endDate)}
                          </span>
                        </div>
                      </div>
                    </GridItem>

                    {/* End Date */}
                    <GridItem xs={12} sm={6} md={6}>
                      <div
                        style={{
                          width: "100%",
                          marginTop: 8,
                        }}
                      >
                        <label
                          htmlFor="endDate"
                          style={{
                            display: "block",
                            fontSize: 13,
                            color:
                              touched.endDate && !endDate ? "#f44336" : "#777",
                            marginBottom: 5,
                          }}
                        >
                          {endDate ? "End Date" : "Select End Date"}
                        </label>

                        <input
                          id="endDate"
                          name="endDate"
                          type="date"
                          min={getLocalDateInputValue(startDate)}
                          max={getLocalDateInputValue(maxEnd)}
                          value={getLocalDateInputValue(endDate)}
                          onChange={onEndDateChange}
                          disabled={loading}
                          style={{
                            width: "100%",
                            height: 40,
                            padding: "0 8px",
                            border: "none",
                            borderBottom: `1px solid ${
                              touched.endDate && !endDate ? "#f44336" : "#ccc"
                            }`,
                            outline: "none",
                            backgroundColor: "#fff",
                            color: endDate ? "#333" : "#999",
                            fontSize: 16,
                            fontFamily: "inherit",
                            boxSizing: "border-box",
                          }}
                        />

                        {touched.endDate && !endDate && (
                          <div
                            style={{
                              color: "#f44336",
                              fontSize: 12,
                              marginTop: 4,
                            }}
                          >
                            End date is required.
                          </div>
                        )}
                      </div>
                    </GridItem>

                    {/* Offer */}
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Offer"
                        id="offer"
                        inputProps={{
                          placeholder:
                            "e.g. 10% off Making charge on first bulk Order",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="offer"
                        value={offer}
                        onChange={(event) => {
                          setOffer(event.target.value);
                        }}
                        disabled={loading}
                      />
                    </GridItem>

                    {/* Hashtags */}
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText={
                          <span
                            style={{
                              color: getLabelColor("hashtags", hashtags),
                            }}
                          >
                            Hashtags...
                          </span>
                        }
                        id="hashtags"
                        inputProps={{
                          placeholder: "e.g. #handmade #jewelry #mumbai",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="hashtags"
                        value={hashtags}
                        onChange={(event) => {
                          setHashtags(event.target.value);
                          setTouched((previous) => ({
                            ...previous,
                            hashtags: true,
                          }));
                        }}
                        disabled={loading}
                      />
                    </GridItem>
                  </>
                ) : (
                  ""
                )}
              </GridContainer>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 16,
                }}
              >
                <Button
                  color="rose"
                  onClick={handleUpdate}
                  disabled={loading}
                  style={{
                    opacity: loading ? 0.6 : 1,
                    cursor: loading ? "not-allowed" : "pointer",
                  }}
                >
                  {loading ? "Updating..." : "Update Posts"}
                </Button>
              </div>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

UpdatePosts.propTypes = {
  avatar: PropTypes.bool,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
};
